import ReplyIcon from '@mui/icons-material/Reply';
import { Tooltip, Box, Typography } from '@mui/material';
import { TypographyCheckSell } from '../style/typography';
import { CheckboxCell } from '../style/tablecell';

export const PageNavigateCheckboxCell = ({ cellLabel, uuid, tooltipText = "事業者一覧ページに遷移", subLabel }) => {

  const handleClick = (e) => {
    e.stopPropagation();
    const url = `/first_report_powerplant_patrol/${uuid}`;
      window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <CheckboxCell>
      <Tooltip title={tooltipText} arrow>
        <span style={{ display: "flex", alignItems: "center", textAlign: "center", cursor: 'pointer' }} onClick={handleClick}>
          <ReplyIcon
            fontSize="small"
            sx={{ marginRight: 0.5, color: "#0A7CB7", transform: 'scaleX(-1)' }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <TypographyCheckSell>{cellLabel}</TypographyCheckSell>
            {subLabel && (
              <Typography
                sx={{
                  color: 'red',
                  fontSize: '0.7rem',
                  fontWeight: 'bold',
                  lineHeight: 1.2,
                  marginTop: '2px'
                }}
              >
                {subLabel}
              </Typography>
            )}
          </Box>
        </span>
      </Tooltip>
    </CheckboxCell>
  );
};

export default PageNavigateCheckboxCell;